export const xpLevelImages = {
  1: { image: 'douglas_blue_idling.png', name: 'Blue Douglas' },
  2: { image: 'douglas_orange_idling.png', name: 'Orange Douglas' },
  3: { image: 'douglas_yellow_idling.png', name: 'Yellow Douglas' },
  4: { image: 'douglas_red_idling.png', name: 'Red Douglas' },
  5: { image: 'douglas_white_idling.png', name: 'White Douglas' },
  6: { image: 'douglas_black_idling.png', name: 'Black Douglas' },
  7: { image: 'rust_blue_idling.png', name: 'Rust Blue' },
  8: { image: 'rust_orange_idling.png', name: 'Rust Orange' },
  9: { image: 'rust_yellow_idling.png', name: 'Rust Yellow' },
  10: { image: 'rust_red_idling.png', name: 'Rust Red' },
  11: { image: 'rust_white_idling.png', name: 'Rust White' },
  12: { image: 'rust_black_idling.png', name: 'Rust Black' },
  13: { image: 'ada_blue_idling.png', name: 'Ada Blue' },
  14: { image: 'ada_orange_idling.png', name: 'Ada Orange' },
  15: { image: 'ada_yellow_idling.png', name: 'Ada Yellow ' },
  16: { image: 'ada_red_idling.png', name: 'Ada Red' },
  17: { image: 'ada_white_idling.png', name: 'Ada White' },
  18: { image: 'ada_black_idling.png', name: 'Ada Black' },
  19: { image: 'skilly_blue_idling.png', name: 'Skilly Blue' },
  20: { image: 'skilly_orange_idling.png', name: 'Skilly Orange' },
  21: { image: 'skilly_yellow_idling.png', name: 'Skilly Yellow' },
  22: { image: 'skilly_red_idling.png', name: 'Skilly Red' },
  23: { image: 'skilly_white_idling.png', name: 'Skilly White' },
  24: { image: 'skilly_black_idling.png', name: 'Skilly Black' },
  25: { image: 'katniss_blue_idling.png', name: 'Katniss Blue' },
  26: { image: 'katniss_orange_idling.png', name: 'Katniss Orange' },
  27: { image: 'katniss_yellow_idling.png', name: 'Katniss Yellow' },
  28: { image: 'katniss_red_idling.png', name: 'Katniss Red' },
  29: { image: 'katniss_white_idling.png', name: 'Katniss White' },
  30: { image: 'katniss_black_idling.png', name: 'Katniss Black' },
  default: { image: 'ada_top_level.png', name: 'Ada Top Level' },
};
